import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { memo, useMemo } from 'react';
import { formatAssetClassLabel, getAssetClassColors } from '../../../../../shared/dashboard';
import theme from '../../../../../theme';
import { Dashboard } from '../../../../../types/files';

const useStyles = makeStyles(() => ({
  badge: {
    height: '30px',
    width: 'auto',
    padding: '0 12px',
    borderRadius: '24px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    userSelect: 'none',
  },
  badgeText: {
    fontFamily: 'Inter',
    fontSize: '0.8rem',
    fontWeight: 500,
    lineHeight: '30px',
  },
}));

const AssetClassCell: React.FC<{ dashboard: Dashboard }> = ({ dashboard }) => {
  const classes = useStyles();
  const hasAssetClass = !!dashboard.assetClass?.trim();
  const label = formatAssetClassLabel(dashboard.assetClass);
  const colors = useMemo(() => getAssetClassColors(dashboard.assetClass), [dashboard.assetClass]);

  if (!hasAssetClass) {
    return (
      <Typography
        fontFamily="Lato"
        fontSize="0.9rem"
        fontWeight={500}
        color={theme.colors.neutral['500']}
      >
        {label}
      </Typography>
    );
  }

  return (
    <Box
      className={classes.badge}
      sx={{
        backgroundColor: colors.bg,
        border: `1px solid ${colors.border}`,
      }}
    >
      <Typography className={classes.badgeText} sx={{ color: colors.text }}>
        {label}
      </Typography>
    </Box>
  );
};

export default memo(AssetClassCell);
